import { IconType } from "react-icons/lib/esm/iconBase";

import { PreferredLocale } from "../../../../utils/locales";
import {
  CourseInstructionType,
  CourseUnitView,
  ICourseEditOperations,
  ICourseInstruction,
  ICourseNavigationOperations,
  IFullCourse,
} from "../../../course-author/types";

export enum DragAndDropTypes {
  UnitListItem = "UnitListItem",
  InstructionListItem = "InstructionMaterialListItem",
}

export interface IUnitTreeProps {
  alternateColor?: boolean;
  course: IFullCourse;
  courseId: string;
  currentLocale: PreferredLocale;
  editOperations: ICourseEditOperations;
  maxTitleWidth: number;
  navigationOperations: ICourseNavigationOperations;
  unitPath: CourseUnitView[];
  userId: string;
}

export interface IInstructionalMaterialGroupProps {
  editOperations: ICourseEditOperations;
  navigationOperations: ICourseNavigationOperations;
  course: IFullCourse;
  courseId: string;
  Icon: IconType;
  instructionalMaterials: {
    [key in CourseInstructionType]: ICourseInstruction[];
  };
  instructionType: CourseInstructionType;
  locale: PreferredLocale;
  maxTitleWidth: number;
  unitPath: CourseUnitView[];
  unitUrl: string;
  bgColor: string;
}
